module.exports = __webpack_public_path__ + "img/chateau_vecquee_mirroir.87c18ef3.jpg";